import { render, staticRenderFns } from "./logData.vue?vue&type=template&id=083f2cbd&scoped=true"
import script from "./logData.vue?vue&type=script&lang=js"
export * from "./logData.vue?vue&type=script&lang=js"
import style0 from "./logData.vue?vue&type=style&index=0&id=083f2cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f2cbd",
  null
  
)

export default component.exports